import { FC } from "react";
import { PageWrapper } from "@connectedComponents";
import { Button, Drawer, Icon, Modal, Input } from "@components";
import { useControllers } from "./useControllers";
import {
  BasketButtonComponent,
  CategoryList,
  ProductList
} from "../components";
import { formatPrice } from "@utilities/functions";

export const Shop: FC = () => {

  const {
    isCartOpen, selectedCategoryName,
    isDrawerOpen, products, baskets,
    activeBasket, categories, productsPagination,
    basketListModal, setBasketListModal, totalSavings,
    searchTerm, isSearching, searchProductsLoading,
    handleDrawerClose, onDeleteBasket,
    handleDrawerToggle, handleChangePage,
    toggleCart, setActiveBasket,
    onAddProductInBasket, handleSearchChange,
    onRemoveProductInBasket, handleCancelSearch,
    handleGetProductsByCategory
  } = useControllers();

  return (
    <PageWrapper
      onDrawerToggle={handleDrawerToggle}
      activeStack="shopStack"
    >
      <div className="relative pt-4">
        <Button
          variant="info"
          className="rounded-btn absolute top-0 right-0"
          onClick={() => setBasketListModal(true)}
        >
          <div className="relative">
            <Icon iconName='ShoppingBasket' size={20} />
            {baskets.length > 0 && (
              <div className="badge badge-error badge-xs absolute -top-1 -right-1">
                {baskets.length}
              </div>
            )}
          </div>
          Gérer les paniers
        </Button>

        {/* Barre de recherche */}
        <div className="mb-6 max-w-md mt-10 md:mt-0">
          <div className="relative">
            <Input
              placeholder="Rechercher un produit..."
              value={searchTerm}
              onChange={(e) => handleSearchChange(e.target.value)}
              className="pr-20"
            />
            <div className="absolute inset-y-0 right-0 flex items-center gap-1 pr-3">
              {searchProductsLoading && (
                <div className="loading loading-spinner loading-xs"></div>
              )}
              {isSearching && searchTerm && (
                <Button
                  variant="error"
                  onClick={handleCancelSearch}
                  className="btn-circle btn-xs"
                >
                  <Icon iconName="X" size={14} />
                </Button>
              )}
              <Icon iconName="Search" size={16} />
            </div>
          </div>
          {isSearching && (
            <p className="text-sm text-gray-500 mt-1">
              Résultats de recherche pour "{searchTerm}"
            </p>
          )}
        </div>

        <BasketButtonComponent
          isCartOpen={isCartOpen}
          basket={activeBasket}
          totalSavings={totalSavings}
          toggleCart={toggleCart}
          onStacheBasket={() => setActiveBasket(null)}
          onAddProductInBasket={onAddProductInBasket}
          onRemoveProductInBasket={onRemoveProductInBasket}
        />

        <ProductList
          productsPagination={productsPagination}
          categoryName={selectedCategoryName}
          products={products}
          basket={activeBasket}
          handleChangePage={handleChangePage}
          onAddProductInBasket={onAddProductInBasket}
          onRemoveProductInBasket={onRemoveProductInBasket}
        />

        <Drawer
          isOpen={isDrawerOpen}
          onClose={handleDrawerClose}
          drawerContent={
            <CategoryList
              resetCategoryName={() => { }}
              categories={categories}
              onCategoryChange={handleGetProductsByCategory}
            />
          }
        />

        <Modal
          isOpen={basketListModal}
          onClose={() => setBasketListModal(false)}
          title="Mes paniers"
        >
          <div className="space-y-3">
            {baskets.map((basket) => {
              const isActive = activeBasket?._id === basket._id;

              return (
                <div
                  key={basket._id}
                  className={`flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2 sm:gap-4 p-4 rounded-lg border shadow-sm ${isActive ? 'bg-primary/10 border-primary' : 'bg-white'
                    }`}
                >
                  {/* Infos panier */}
                  <div className="flex-1">
                    <p className="text-sm text-gray-700">
                      <span className="font-semibold">{basket.basket.length} article(s)</span> — Total :{' '}
                      <span className="font-semibold">{formatPrice(basket.totalAmount)}</span>
                    </p>
                  </div>

                  {/* Boutons */}
                  <div className="flex gap-2">
                    <Button
                      variant={isActive ? 'primary' : 'info'}
                      disabled={isActive}
                      className="min-w-[130px]"
                      onClick={() => setActiveBasket(basket)}
                    >
                      {isActive ? 'Panier en cours' : 'Charger le panier'}
                    </Button>

                    <Button
                      variant="error"
                      className="btn-square"
                      disabled={isActive}
                      onClick={() => onDeleteBasket(basket._id)}
                    >
                      <Icon iconName="Trash2" size={20} />
                    </Button>
                  </div>
                </div>
              );
            })}
          </div>
        </Modal>
      </div>
    </PageWrapper>
  );
};
